import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../features/authSlice";
import MainLayout from "../pages/layout/MainLayout";
import LoginPage from "../pages/auth/login";
import HomePage from "../pages/home";
import CarTranserList from "../pages/cartransfer/List";
import CarTransferCreate from "../pages/cartransfer/Create";
import CartransferMobile from "../pages/cartransfer/Mobile";
import CartransferPayF23 from "../pages/cartransfer/PayF23";
import CartransferFolder from "../pages/cartransfer/Folder";
import UserCreate from "../pages/user/Create";
import Glossary from "../pages/glossary";
import CartransferDetails from "../pages/cartransfer/Details";
import NotFound from "../pages/result/NotFound";
import ClientsPage from "../pages/clients";
import PrivateRoute from "./PrivateRoute";
import NotaryDocuments from "../pages/admin/NotaryDocuments";
import Announcements from "../pages/admin/Announcements";
import RepertoryIndexAdmin from "../pages/admin/RepertoryIndexAdmin";
import MyDocuments from "../pages/admin/MyDocuments";
import PortalLayout from "../pages/portal/PortalLayout";
import PortalLogin from "../pages/portal/PortalLogin";
import PortalRegister from "../pages/portal/PortalRegister";
import PortalForgotPassword from "../pages/portal/PortalForgotPassword";
import PortalProfile from "../pages/portal/PortalProfile";
import PortalDocuments from "../pages/portal/PortalDocuments";
import PortalSearchIndex from "../pages/portal/PortalSearchIndex";
import PortalRoute from "./PortalRoute";
import PortalActivityLog from "../pages/admin/PortalActivityLog";

const ADMIN_ROLES = ['user', 'admin'];

const RootRedirect = () => {
  const { role } = useSelector(userSelector);
  return <Navigate to={ADMIN_ROLES.includes(role) ? "/admin" : "/portal"} replace />;
};

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Login del sistema notarial */}
      <Route path="/login" element={<LoginPage />} />

      {/* Rutas protegidas del sistema notarial */}
      <Route path="/admin" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<HomePage />} />
        <Route path="cartransfers">
          <Route path="list" element={<CarTranserList />} />
          <Route path="new" element={<CarTransferCreate />} />
          <Route path="edit/:cartransferId" element={<CarTransferCreate />} />
          <Route path="mobile/:roomId" element={<CartransferMobile />} />
          <Route path="pay/:cartransferId" element={<CartransferPayF23 />} />
          <Route path="folder/:cartransferId" element={<CartransferFolder />} />
        </Route>
        <Route path="users">
          {/* Redirigir la lista antigua a la nueva página de clientes */}
          <Route path="list" element={<Navigate to="/admin/clients" replace />} />
          <Route path="list/:role" element={<Navigate to="/admin/clients" replace />} />
          <Route path="new" element={<UserCreate />} />
          <Route path=":userId" element={<UserCreate />} />
        </Route>
        <Route path="clients" element={<ClientsPage />} />
        <Route path="glossary" element={<Glossary />} />
        <Route path="notary-documents" element={<NotaryDocuments />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="repertory-index" element={<RepertoryIndexAdmin />} />
        <Route path="search-index" element={<PortalSearchIndex />} />
        <Route path="my-documents" element={<MyDocuments />} />
        <Route path="portal-activity" element={<PortalActivityLog />} />
      </Route>

      {/* Rutas públicas del portal de clientes */}
      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/register" element={<PortalRegister />} />
      <Route path="/portal/forgot-password" element={<PortalForgotPassword />} />

      {/* Rutas privadas del portal de clientes */}
      <Route
        path="/portal"
        element={<PortalRoute><PortalLayout /></PortalRoute>}
      >
        <Route index element={<Navigate to="/portal/documents" replace />} />
        <Route path="profile" element={<PortalProfile />} />
        <Route path="search-index" element={<PortalSearchIndex />} />
        <Route path="documents" element={<PortalDocuments />} />
      </Route>

      {/* Rutas públicas o especiales */}
      <Route path="qr/cartransfer/:cartransferId" element={<CartransferDetails />} />

      {/* Redirección raíz según rol */}
      <Route path="/" element={<RootRedirect />} />

      {/* Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AdminRoutes;
